<template>
  <div class="qr-container">
    <div class="scanner-wrapper" v-if="!decodedResult && stream">
      <qrcode-stream
        :camera="camera"
        @decode="onDecode"
        @init="onInit"
        @error="onError"
        :key="scannerKey"
      />
    </div>
    <div class="text-center">
      <button @click="scanAgain" class="btn btn-primary mt-2">
        Scan Again
      </button>&nbsp;&nbsp;&nbsp;
      <button @click="this.$router.go(-1);" class="btn btn-danger mt-2">
        Go Back 
      </button>
    </div>

    <div v-if="decodedResult" class="result-box">
      <strong>Decoded Result:</strong> {{ decodedResult }}
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue3-qrcode-reader';

export default {
  components: {
    QrcodeStream
  },
  data() {
    return {
      decodedResult: null,
      scannerKey: 0,
      stream: null,
      camera: 'auto' // Changed from stream to camera property
    };
  },
  methods: {
    async initFrontCamera() {
      try {
        // First try to get back camera
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" }
        });
        this.camera = 'auto'; // Let the component handle the stream
        this.stopStream(); // Stop any existing stream
        this.stream = stream;
      } catch (err) {
        console.warn("Back camera not available, trying front camera...");
        try {
          // Then try front camera
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "user" }
          });
          this.camera = 'auto';
          this.stopStream();
          this.stream = stream;
        } catch (err) {
          console.warn("Front camera not available, falling back to default.");
          // Finally try any camera
          const stream = await navigator.mediaDevices.getUserMedia({
            video: true
          });
          this.camera = 'auto';
          this.stopStream();
          this.stream = stream;
        }
      }
    },
    stopStream() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }
    },
    onDecode(decodedString) {
      this.decodedResult = decodedString;

      if (decodedString.startsWith("http")) {
        setTimeout(() => {
          window.location.replace(decodedString);
        }, 300);
      } else {
        alert("Invalid QR code content: " + decodedString);
      }
    },
    onInit(promise) {
      promise
        .then(() => {
          console.log("QR code reader initialized");
        })
        .catch((error) => {
          console.error("QR code reader initialization failed", error);
        });
    },
    onError(error) {
      console.error("Error reading QR code", error);
    },
    async scanAgain() {
      this.decodedResult = null;
      this.scannerKey++;
      await this.initFrontCamera();
    }
  },
  mounted() {
    this.initFrontCamera();
  },
  beforeUnmount() {
    this.stopStream();
  }
};
</script>

<style scoped>
/* All your existing styles remain exactly the same */
.qr-container {
  width: 100%;
  max-width: 420px;
  margin: 1rem auto;
  padding: 1rem;
  border-radius: 12px;
  background-color: #fff;
}
.scanner-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: auto;
  aspect-ratio: 3/4; /* Mobile-friendly tall view */
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.scanner-wrapper video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}
.result-box {
  margin-top: 1rem;
  padding: 0.8rem;
  background-color: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 8px;
  font-size: 1rem;
  color: #2e7d32;
  word-wrap: break-word;
}

.scanner-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 1 / 1; /* Square shape */
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

/* Use deep selector to style internal video element */
::v-deep video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover; /* Fill the square, can change to 'contain' if needed */
  display: block;
}
</style>